import * as React from 'react';

import * as styles from './styles.css';
import { BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT } from '../../constants/experiments';
import { experimentToggle } from '../experimentToggle';

interface ICardActionsLayout {
  isRedesignExperimentActive: boolean;
}

export function CardActionsLayout({
  isRedesignExperimentActive,
  children,
}: React.PropsWithChildren<ICardActionsLayout>) {
  /**
   * @todo experimentToggle - временное решение, удалить после завершения эксперимента aud_mobile_bx585_saved_search_favorites_merge
   */
  return experimentToggle(
    isRedesignExperimentActive,
    BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT,
    <div className={styles['container']}>{children}</div>,
    <div className={styles['container--redesign']}>{children}</div>,
  );
}
